/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { settingsCmdbFieldConfigRoute } from '@jira/router-routes__settings-cmdb-field-config-routes/src/settingsCmdbFieldConfigRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	AsyncCmdbFieldConfigPage,
	LazyCMDBFieldConfigAdmin,
} from './ui/admin-pages/cmdb-field-config/index.tsx';

export const settingsCmdbFieldConfigRouteEntry: Route = createEntry(
	settingsCmdbFieldConfigRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.cmdb-field-config',
		// eslint-disable-next-line no-restricted-syntax
		component: AsyncCmdbFieldConfigPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource, workspaceResource],
		forPaint: [LazyAtlassianNavigation, LazyCMDBFieldConfigAdmin],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
